import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Box } from '@mui/material'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { clearStatus, selectStartdelivery, startdelivery } from 'slices/startdeliverySlice'
import { DriverInput } from 'components/DriverInput/DriverInput'

export const Derivery = () => {
  const dispatch = useAppDispatch()
  const { sessionId, status } = useAppSelector(selectStartdelivery)

  const location = useLocation()
  const query = useMemo(() => new URLSearchParams(location.search), [location.search])

  useEffect(() => {
    dispatch(clearStatus())

    const connect1 = query.get('connect1')
    if (connect1) {
      dispatch(startdelivery(connect1))
    }
  }, [dispatch, query])

  const showDriverInput = useMemo(() => status === 'success' && !!sessionId, [sessionId, status])

  return <Box>{showDriverInput && <DriverInput />}</Box>
}
